import getFullName from "../utils/getFullName";
const ENDPOINT = process.env.REACT_APP_ENDPOINT

async function getActorById(actorId) {
    const baseUrl = `${ENDPOINT}/actor`;
    const url = `${baseUrl}/${actorId}`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return {...data, name: getFullName(data)};
    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
    }
}

export default getActorById;